import React, { useState, useEffect } from 'react'

import InputBox from '../../../../components/InputBox'
import Button from '../../../../components/Button'
import Dropdown from '../../../../components/Dropdown/Dropdown'
import { Table } from 'semantic-ui-react'
import { ToastContainer, toast } from 'react-toastify'

import fetchShowcaseV2Plans from '../../../../services/fetchShowcaseV2Plans'
import fetchCompanyList from '../../../../services/fetchCompanyList'
import addShowcaseV2Plan from '../../../../services/addShowcaseV2Plan'
import updateShowcaseV2Plan from '../../../../services/updateShowcaseV2Plan'

import { default as adminProfile } from '../../../../store/user';
import { getQueryParams } from '../../../../utils/utilFunctions'

import moment from 'moment'

import './PlanAdd.scss'

export const PlanAdd = (props) => {

    const [adminId, setAdminId] = useState(null)
    const [user, setUser] = useState('')
    const [userInputError, setUserInputError] = useState('')
    const [showTable, setShowTable] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [planData, setPlanData] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [companyList, setCompanyList] = useState([])
    const [formData, setFormData] = useState({
        recruiterId: '',
        domain: '',
        company: '',
    })
    const [formError, setFormError] = useState('')

    // eslint-disable-next-line react/prop-types
    const urlParams = getQueryParams(props.location.search)

    useEffect(() => {
        (async () => {
            const profile = await adminProfile.getProfile();
            setAdminId(profile.id)
            const { data } = await fetchCompanyList(profile.id);
            const list = [{ id: '', name: 'Select Company' }, ...data.data];
            setCompanyList(list);

            // params
            if (urlParams.id) {
                setIsEdit(true);
                const response = await fetchShowcaseV2Plans(profile.id, { autoId: urlParams.id });
                setShowForm(true);
                setFormData({
                    recruiterId: response.data.data.data[0].recruiterId,
                    domain: response.data.data.data[0].domain,
                    company: response.data.data.data[0].companyId,
                });
            }
        })()
    }, []);

    const onChange = (ev) => {
        setUser(ev.target.value)
        setUserInputError('');
    }

    const changeHandler = (ev) => {
        const { name, value } = ev.target
        setFormData((form) => ({ ...form, [name]: value }))
    }

    const onKeyPress = (ev) => {
        if (ev.key == 'Enter') {
            onSearch();
        }
    }

    const onSearch = async () => {
        if (user) {
            const params = { user, };
            try {
                const { data } = await fetchShowcaseV2Plans(adminId, params);
                setIsEdit(false);
                if (data.data.data.length) {
                    setShowTable(true);
                    setShowForm(false);
                    setFormData({
                        recruiterId: '',
                        domain: '',
                        company: '',
                    });
                } else {
                    setShowForm(true);
                    setShowTable(false);
                    setFormData((form) => ({
                        ...form,
                        recruiterId: data.data.recruiterId,
                        domain: '',
                        company: '',
                    }));
                }
                setUserInputError('');
                setPlanData(data.data.data);
            } catch (error) {
                if (error.message == 'Request failed with status code 400') {
                    setUserInputError('No Recruiter Found');
                }
                setShowForm(false);
                setShowTable(false);
            }
        } else {
            setUserInputError('Please Enter email or recruiter id');
        }
    }

    const validate = () => {
        for (const field in formData) {
            if (!formData[field] || ( typeof formData[field] === 'string' && !formData[field].trim())) {
                return false;
            }
        }
        return true;
    }

    const onSubmit = async () => {
        if (validate()) {
            setFormError('');
            let companyName = '';
            for (const company of companyList) {
                if (company.id == formData.company) {
                    companyName = company.name;
                    break;
                }
            }
            const data = {
                recruiterId: formData.recruiterId,
                companyId: formData.company,
                domain: formData.domain,
                companyName,
            }
            let res;
            if (isEdit && urlParams.id) {
                data.autoId = urlParams.id;
                res = await updateShowcaseV2Plan(adminId, data);
            } else {
                res = await addShowcaseV2Plan(adminId, data);
            }
            setShowForm(false);
            setFormData({
                recruiterId: '',
                domain: '',
                company: '',
            });
            toast.info(res.data.message);
            // eslint-disable-next-line no-undef
            setTimeout(() => {
                // eslint-disable-next-line no-undef
                window.location.href = '/showcasePlanAdd';
            }, 2000);
        } else {
            setFormError('Please Enter Valid Details');
        }
    }

    return (
        <div className='showcase-plan-add-container'>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable={false}
                pauseOnHover
            />
            < div className='topbar'>
                <div className='page-heading'>
                    <h4>Search for recruiters</h4>
                </div>
                <div className='redirect-btns'>
                    <Button
                        text='Plan Management'
                        skin='light'
                        // eslint-disable-next-line no-return-assign, no-undef
                        clickButton={() => window.location.href = '/showcasePlanList'}
                    />
                    <Button
                        className='older-version-btn'
                        text='Go to Older Version'
                        skin='light'
                        // eslint-disable-next-line no-return-assign, no-undef
                        clickButton={() => window.location.href = `${process.env.REACT_APP_CLIENT_URL}/recruiter/showcasePlanAdd.php`}
                    />
                </div>
            </div>
            <div className='search-container'>
                <div className='user-input-field'>
                    <InputBox
                        name="recruiter"
                        type="text"
                        placeholder="Enter email or ID"
                        value={user}
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                    />
                    <span className='error-text error-field'>{userInputError}</span>
                </div>
                <Button
                    text="Search"
                    skin="light"
                    clickButton={onSearch}
                />
                <Button
                    text="Clear Filters"
                    skin="dark"
                    // eslint-disable-next-line no-return-assign, no-undef
                    clickButton={() => window.location.href = '/showcasePlanAdd'}
                />
            </div>
            {showTable ?
                <div className='plan-list-container'>
                    <Table
                        fixed
                        selectable
                        className="plan-list"
                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    Showcase Id
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Recruiter Id
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Company
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Domain
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Created By
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Created On
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {planData.map((plan) => {
                                return (
                                    <Table.Row>
                                        <Table.Cell>
                                            {plan.id}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {plan.recruiterId}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {plan.companyId} - {plan.companyName}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {plan.domain}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {plan.createdBy}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {moment(plan.createdOn).format('YYYY-MM-DD hh:mm:ss')}
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })}
                        </Table.Body>
                    </Table>
                </div>
                :
                null
            }
            {showForm ?
                <div className='edit-plan-form'>
                    <h4>{isEdit ? 'Edit' : 'Add'} Plan</h4>
                    <div className='form-group'>
                        <label>Recruiter ID<span className='mandatory-mark'>*</span></label>
                        {formData.recruiterId}
                    </div>
                    <div className='form-group'>
                        <label>Domain<span className='mandatory-mark'>*</span></label>
                        <InputBox
                            type="text"
                            name="domain"
                            value={formData.domain}
                            onChange={changeHandler}
                            className="formInput"
                        />
                    </div>
                    <div className='form-group'>
                        <label>Company<span className='mandatory-mark'>*</span></label>
                        <Dropdown
                            name="company"
                            className="formInput"
                            data={companyList}
                            dropdownChange={changeHandler}
                            defaultValue={formData.company}
                        />
                    </div>
                    <div className='error-text form-group'>{formError}</div>
                    <Button
                        text="Submit"
                        skin="light"
                        clickButton={onSubmit}
                    />
                </div>
                :
                null
            }
        </div>
    )
}
